import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import FeedbackModal from "./FeedbackModal";
import BackButton from "./BackButton";
import feedbackService from "../services/feedbackService";
import "./serviceUi.css";
import "./InitialFeedbackModal.css";

const GOOGLE_REVIEW_URL =
  "https://www.google.com/search?kgmid=/g/11gfnjv45b&hl=en-PH&q=AMAPHIL+(Advanced+Medical+Access+Philippines+Inc.)&shndl=30&shem=lcuae,lstl2&source=sh/x/loc/osrp/m5/1&kgs=bd89a630b62eba8c#lrd=0x3397c9aea18bc557:0x4703d185bcfaa8a5,3,,,,";

const InitialFeedbackModal = ({ isOpen, onClose }) => {
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  const location = useLocation();

  // Happy members are sent to the Google review page
  const handleYesClick = () => {
    const encryptedData = new URLSearchParams(location.search).get("data");
    feedbackService.recordFeedbackSubmission(encryptedData);
    window.location.href = GOOGLE_REVIEW_URL;
  };

  const handleNoClick = () => setShowFeedbackModal(true);

  if (!isOpen) return null;

  return (
    <>
      <div
        className="sheet-overlay feedback-overlay"
        role="dialog"
        aria-modal="true"
        aria-labelledby="experience-title"
      >
        <div className="sheet-card feedback-card">
          <BackButton onClick={onClose} className="sheet-back" />
          <button type="button" className="sheet-close" onClick={onClose} aria-label="Close">
            <FontAwesomeIcon icon={faTimes} />
          </button>
          <p className="sheet-eyebrow">Quick question</p>
          <h2 id="experience-title" className="sheet-title">How was your experience?</h2>
          <p className="sheet-subtitle">Your feedback helps us serve you better.</p>
          <div className="feedback-choices">
            <button type="button" onClick={handleYesClick} className="feedback-choice feedback-choice--great">
              <span className="feedback-choice__emoji" aria-hidden="true">😊</span>
              <span>Great</span>
            </button>
            <button type="button" onClick={handleNoClick} className="feedback-choice feedback-choice--poor">
              <span className="feedback-choice__emoji" aria-hidden="true">😞</span>
              <span>Not great</span>
            </button>
          </div>
        </div>
      </div>
      <FeedbackModal
        isOpen={showFeedbackModal}
        onBack={() => setShowFeedbackModal(false)}
        onClose={() => {
          setShowFeedbackModal(false);
          onClose();
        }}
      />
    </>
  );
};

export default InitialFeedbackModal;
